import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { LocalStoreService } from '../services/local-store.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private store: LocalStoreService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (this.store.getItem('user')) {
      // this.authService.checkTokenExpiration(this.store.getItem('user').user.stsTokenManager.accessToken);
      const user = this.store.getItem('user');
      if (user) {
        return true;
      }
      // this.router.navigate(['/auth/sign-in'], { queryParams: { returnUrl: state.url } });
      this.router.navigate(['/404']);
      return false;
    } else {
      this.authService.logOut();
      this.router.navigate(['/']);
      return false;
    }
  }
}
